import { useState, useEffect } from 'react'

let cachedResponsiveState = null
let listeners = []

function getAllResponsiveValues() {
  const width = typeof window !== 'undefined' ? window.innerWidth : 1024
  const responsive_type_0 = width > 550

  const responsive_type_1 = (() => {
    if (width > 550 && width <= 1024) return 'is_responsive is-tablet-view'
    return width > 550 ? 'is_responsive' : ''
  })()

  const responsive_type_2 = width >= 550
  return {
    responsive_type_0,
    responsive_type_1,
    responsive_type_2,
  }
}

function subscribe(listener) {
  listeners.push(listener)
  return () => {
    listeners = listeners.filter(l => l !== listener)
  }
}

function notifyAll(newState) {
  listeners.forEach(listener => listener(newState))
}

if (typeof window !== 'undefined' && !window.__responsiveModuleInitialized) {
  cachedResponsiveState = getAllResponsiveValues()
  window.addEventListener('resize', () => {
    const newState = getAllResponsiveValues()
    cachedResponsiveState = newState
    notifyAll(newState)
  })
  window.__responsiveModuleInitialized = true
}

export const useResponsiveModule = () => {
  const [responsiveState, setResponsiveState] = useState(() => {
    if (cachedResponsiveState) return cachedResponsiveState
    return getAllResponsiveValues()
  })

  useEffect(() => {
    if (cachedResponsiveState && cachedResponsiveState !== responsiveState) {
      setResponsiveState(cachedResponsiveState)
    }
    const unsubscribe = subscribe(setResponsiveState)
    return () => unsubscribe()
  }, [responsiveState])

  return responsiveState
}
